import useSWR from "swr";
import { CalendarDays, Package, Ticket, Mail, IndianRupee } from "lucide-react";
import { fetcher } from "@/lib/api";

const inr = (n) => `₹${(n || 0).toLocaleString("en-IN")}`;

export function Overview({ goTo }) {
  const { data: o } = useSWR("/admin/overview", fetcher);
  const cards = o
    ? [
        { k: "meetings", icon: CalendarDays, v: o.meetings_upcoming, l: "Upcoming meetings", s: `${o.meetings_total} total` },
        { k: "orders", icon: Package, v: o.orders_total, l: "Sample orders", s: `${o.orders_paid} paid · ${inr(o.orders_revenue)}` },
        { k: "pli", icon: Ticket, v: o.pli_total, l: "PLI registrations", s: `${o.pli_paid} paid · ${inr(o.pli_revenue)}` },
        { k: "messages", icon: Mail, v: o.messages_total, l: "Contact messages", s: "From the contact form" },
      ]
    : [];
  return (
    <div data-testid="admin-overview">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(({ k, icon: Icon, v, l, s }) => (
          <button key={k} onClick={() => goTo(k)} data-testid={`overview-card-${k}`} className="text-left rounded-3xl bg-white border border-[#D7D4CF]/70 p-6 gold-hover-border">
            <Icon className="w-5 h-5 text-[#A68840] mb-6" strokeWidth={1.5} />
            <div className="font-editorial text-5xl text-[#1D3A2F]">{v}</div>
            <div className="text-sm text-[#1D3A2F] mt-2">{l}</div>
            <div className="text-xs text-[#556B57] mt-1">{s}</div>
          </button>
        ))}
      </div>
      {o && (
        <div className="mt-6 rounded-3xl bg-[#1D3A2F] text-[#FDFBF7] p-8 flex flex-wrap items-center gap-6">
          <IndianRupee className="w-8 h-8 text-[#C9A961]" />
          <div>
            <div className="text-[10px] tracking-[0.24em] uppercase text-[#E6D5A4]">Total paid revenue</div>
            <div data-testid="overview-revenue" className="font-editorial text-4xl gold-text">{inr(o.orders_revenue + o.pli_revenue)}</div>
          </div>
        </div>
      )}
    </div>
  );
}
